import React, { FC } from 'react';

import { CustomRadio, RadioLabel, RadioWrapper } from './transaction-date-input-form.styled';
import { IRadioOptionProps } from './types';

const RadioOption: FC<React.PropsWithChildren<IRadioOptionProps>> = ({ value, label }) => (
  <RadioWrapper>
    <CustomRadio testID="radio-option" value={value}>
      <RadioLabel>{label}</RadioLabel>
    </CustomRadio>
  </RadioWrapper>
);

export default RadioOption;
